import { makeStyles } from "@material-ui/core/styles";
import { calculateFontSize } from "../../CustomHooks/useThemeHook";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    position: "relative",
    // height: 'auto',
    height: theme?.palette?.card?.cardHeight,
    // height: 152,
    // maxHeight: 152,
    width: "100%",
    cursor: "pointer",
    backgroundColor:
      theme?.palette?.card?.cardColor || theme.palette.common.white,
    // boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.08)",
    borderRadius: theme?.palette?.card?.cardBorderRadius || "12px",
    border: theme?.palette?.card?.cardBorder
      ? `1px solid ${theme?.palette?.card?.cardBorderColor}`
      : null,
    flexDirection: theme?.palette?.card?.position == 0 ? "row" : "row-reverse",

    // [theme.breakpoints.up('sm')]: {
    //     height: 172
    // },
    [theme.breakpoints.up("md")]: {
      height: 180,
      // maxHeight: 180
    },
    "&:hover": {
      opacity: 0.8,
      transform: "scale(1.01)",
    },
  },
  disabled: {
    pointerEvents: "none",
  },
  nxtAvailableTime: {
    color: "#9C0A35",
  },
  cover: {
    // maxWidth: 'calc(100% - 232px)',
    // minWidth: 111,
    height: "100%",
    width: "auto",
    // minHeight: 125,
    // maxHeight: 125,
    minWidth: 125,
    maxWidth: 125,
    // minWidth: 142,
    // maxWidth: 215,
    // width: 111,
    borderTopLeftRadius:
      theme?.palette?.card?.position == 0
        ? theme?.palette?.card?.cardBorderRadius || "12px"
        : 0,
    borderBottomLeftRadius:
      theme?.palette?.card?.position == 0
        ? theme?.palette?.card?.cardBorderRadius || "12px"
        : 0,
    [theme.breakpoints.up("sm")]: {
      // maxWidth: 180,
      minWidth: 180,
      // minHeight: 180,
    },
    // [theme.breakpoints.up('md')]: {
    //     maxWidth: 180,
    //     // width: 180,
    // },
  },
  details: {
    // minWidth : '232px',
    // minWidth:  'calc(100% - 215px)'  ,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: theme.spacing(1.6, 1.5, 1.6, 1.6),
  },
  content: {
    height: "100%",
    width: "100%",
    padding: theme.spacing(0),
    marginBottom: theme.spacing(1.5),
  },
  bottomContent: {
    display: "flex",
    padding: theme.spacing(0),
  },
  title: {
    // ...theme.typography.rockwell,
    fontSize: calculateFontSize(18, theme.palette.common.fontVariation),
    fontWeight: 600,
    lineHeight: "22px",
    // color: theme.palette.common.fontTitle,
    color: theme.palette?.card?.cardFontColor,
    // fontSize: theme.typography.pxToRem(16),
    // fontWeight: 600,
    marginBottom: theme.spacing(0.8),
    // paddingRight: theme.spacing(1.6),
    lineClamp: 2,
    display: "-webkit-box",
    boxOrient: "vertical",
    overflow: "hidden",
    [theme.breakpoints.up("md")]: {
      lineClamp: 2,
    },
  },
  priceDiv: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
  },
  bannerText: {
    opacity: 0.6,
    textDecoration: "line-through", // adds the overline effect
  },
  desc: {
    fontSize: calculateFontSize(12, theme.palette.common.fontVariation),
    fontWeight: 400,
    lineHeight: "16px",
    // fontFamily: "Poppins-Regular",
    // display: "none",
    // color: theme.palette.common.fontTitle,
    color: theme.palette?.card?.cardFontColor,

    [theme.breakpoints.up("sm")]: {
      lineClamp: 3,
    },
    lineClamp: 3,
    display: "-webkit-box",
    boxOrient: "vertical",
    overflow: "hidden",
    [theme.breakpoints.up("md")]: {
      lineClamp: 4,
    },
  },
  info: {
    display: "flex",
    alignItems: "center",
    minHeight: 24,
    background: theme.palette.common.bgVariation,
    padding: theme.spacing(0.2, 0.8),
    borderRadius: 8,
  },
  infoText: {
    fontSize: calculateFontSize(12, theme.palette.common.fontVariation),
    fontWeight: 600,
    color: theme.palette.common.bgVariationFont,
    padding: "2px 8px",
    borderRadius: "8px",
  },
  outOfStockText: {
    flexGrow: 1,
    textAlign: "right",
    fontSize: calculateFontSize(14, theme.palette.common.fontVariation),
    fontWeight: 400,
    color: theme.palette.common.red,
  },
  priceText: {
    flexGrow: 1,
    textAlign: "right",
    fontSize: calculateFontSize(16, theme.palette.common.fontVariation),
    fontWeight: 600,
    lineHeight: "20px",
    // color: theme.palette.common.fontTitle,
    color: theme.palette?.card?.cardFontColor,
    // fontSize: theme.typography.pxToRem(16),
    // fontWeight: 600,
  },
  countText: {
    position: "absolute",
    top: 8,
    right: 8,
    padding: theme.spacing(0.2, 0.8),
    // padding: theme.spacing(0.2,0.6),
    fontSize: calculateFontSize(12, theme.palette.common.fontVariation),
    fontWeight: 600,
    color: theme.palette.common.white,
    borderRadius: "10px",
    backgroundColor: theme.palette.primary.main,
  },
}));

export default useStyles;
